<template>
  <div class="detail-airport">
    <div class="detail-airport__banner">
      <div v-if="imgLoaded" class="detail-airport__banner__action">
        <div class="detail-airport__banner__action__saved">
          <button class="btn-regular secondary" @click="toggle">
          <i class="adx-ic_plus"></i>
            <span>Save</span>
          </button>
        </div>
        <div class="detail-airport__banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <div v-else class="detail-airport__banner__noaction">
        <div class="detail-airport__banner__noaction__saved">
          <button class="btn-regular secondary" @click="toggle">
          <i class="adx-ic_plus"></i>
            <span>Save</span>
          </button>
        </div>
        <div class="detail-airport__banner__noaction__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <adx-detail-slider  :class="isPhotosAvailable ? 'detail-airport__banner__img' : 'detail-airport__banner__placeholder'" 
      :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="isPhotosAvailable ? detailSlider : placeholderImage"  />
    </div>
    <div v-if="!infoLoaded" class="loading-container">
      <adx-loading />
    </div>
    <div v-else class="detail-airport__info">
      <div class="detail-airport__info__left">
        <div class="detail-airport__info__left__header">
          <adx-label-custom :color="'#47d1af'" :label="'Airport Lounge'"/>
          <h2 class="large-title title">{{location.title}}</h2>
          <span class="detail-airport__info__left__header--placement subhead">{{type}} . {{media.placement}}</span>
        </div>
        <div v-if="location.media_description" class="detail-airport__info__left__media-desc">
          <div class="detail-airport__info__left__media-desc__title">
            <span class="regular-font">Media Information</span>
          </div>
          <div class="detail-airport__info__left__media-desc__content">
            <p class="subhead">{{location.media_description}}</p>
          </div>
        </div>
        <div v-if="location.media_description == null" class="detail-airport__info__left__media">
          <div class="detail-airport__info__left__media__title">
            <span>Media Information</span>
          </div>
          <div v-if="media.size" class="detail-airport__info__left__media__content">
            <div class="detail-airport__info__left__media__content--item" >
              <span>Screen Size</span>
              <span class="value">{{media.size}}</span>
            </div>
            <div v-if="media.screen" class="detail-airport__info__left__media__content--item">
              <span>Total Screen</span>
              <span class="value">{{media.screen}} Screen</span>
            </div>
            <div v-if="media.resolution" class="detail-airport__info__left__media__content--item">
              <span>Placement</span>
              <span class="value">{{media.placement}}</span>
            </div>
            <div v-if="media.resolution" class="detail-airport__info__left__media__content--item">
              <span>Resolution</span>
              <span class="value">{{media.resolution}}</span>
            </div>
            <div v-if="media.playback" class="detail-airport__info__left__media__content--item">
              <span>Playback</span>
              <span class="value">{{media.playback}} per day</span>
            </div>
          </div>
        </div>
        <div v-if="location.description" class="detail-airport__info__left__about">
          <div class="detail-airport__info__left__about__title">
            <span class="regular-font">About Location</span>
          </div>
          <div class="detail-airport__info__left__about__content">
            <p class="subhead">{{location.description}}</p>
          </div>
        </div>
        <div class="detail-airport__info__left__operatinghour">
          <div class="detail-airport__info__left__operatinghour__title">
            <span class="regular-font">Operation Hours</span>
          </div>
          <div class="detail-airport__info__left__operatinghour__content">
            <div class="detail-airport__info__left__operatinghour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
              <span class="days">{{operatinghour.day}}</span>
              <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">{{operatinghour.time}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="detail-airport__info__left__surrounding">
          <div class="detail-airport__info__left__surrounding__title">
            <span class="regular-font">Surrounding</span>
          </div>
          <div class="detail-airport__info__left__surrounding__content">
            <p class="subhead">{{location.surrounding}}</p>
          </div>
        </div> -->
        <div v-if="demographics.length != 0" class="detail-airport__info__left__traffic">
          <div class="detail-airport__info__left__traffic__title">
            <span class="regular-font">Traffic</span>
          </div>
          <div class="detail-airport__info__left__traffic__content">
            <span>Monthly Traffic : {{location.traffic}} Visitors</span>
          </div>
          <div class="detail-airport__info__left__traffic__content" v-for="(demographic, index) in demographics" :key="index">
            <i :class="demographic.icon"></i>
            <span class="item">{{demographic.text}}</span>
          </div>
        </div>
      </div>
      <div class="detail-airport__info__right">
        <div class="detail-airport__info__right__price">
          <h4 class="subhead title">Price / day</h4>
          <h3 class="medium-title price">{{location.price|formatMoney}}</h3>
        </div>
        <div class="detail-airport__info__right__forbidden">
          <div class="detail-airport__info__right__forbidden--title">
            <i class="icon-warning"></i>
            <span>Forbidden Advertisement</span>
          </div>
          <div class="detail-airport__info__right__forbidden--content">
            <p>{{location.forbidden}}</p>
          </div>
        </div>
         <div class="detail-airport__info__right__address">
          <div class="detail-airport__info__right__address--title">
            <i class="icon-pin"></i>
            <span>Address</span>
          </div>
          <div class="detail-airport__info__right__address--content">
            <p>{{location.address}}</p>
          </div>
        </div>
        <div class="detail-airport__info__right__action">
          <button class="btn-large primary add" @click="showCampaign">Add to Campaign</button>
        </div>
      </div>
    </div>
    <div v-if="infoLoaded" class="detail-airport__footer">
      <div class="detail-airport__footer__left">
        <p class="micro-font title">Price / day</p>
        <p class="medium-title price">{{location.price|formatMoney}}</p>
      </div>
      <div class="detail-airport__footer__right">
        <button class="btn-large btn-block primary" @click="showCampaign">Add to Campaign</button>
      </div>
    </div>
    <adx-modal v-if="isOpen" @modal-close="toggle" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="detailSlider" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{location.title}}</span>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DetailSlider from '@/components/Slider/DetailSlider'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import LoadingPrimary from '@/components/Loading/Primary'
import Modal from '@/components/Modal'
import LabelStatusCustom from '@/components/StatusLabelCustom'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatNumber } from '@/lib/filter'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-detail-page',
  components: {
    'adx-detail-slider': DetailSlider,
    'adx-loading-circle': LoadingSecondary,
    'adx-loading-spin': LoadingSpin,
    'adx-loading': LoadingPrimary,
    'adx-modal': Modal,
    'adx-label-custom': LabelStatusCustom
  },
  props: {

  },
  data() {
    return {
      type: 'Digital Screen',
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isMobile: window.innerWidth < 769,
      isShownCampaign: false,
      campaigns: [],
      category: 'lifestyle',
      location: {
        title: ``,
        // placement: ``,
        type: ``,
        price: ``,
        dailyVisitor: ``,
        address: ``,
        description: ``,
        specification: ``,
        // playback: ``,
        forbidden: ``,
        surrounding: '',
        traffic: '',
        media_description: null
      },
      media: {
        size: null,
        screen: null,
        placement: null,
        resolution: null,
        playback: null,
      },
      detailSlider: [
        // {url: '/img/notfound/img-placeholder_landscape.jpg'},
        // {url: '/img/notfound/img-placeholder_landscape.jpg'},
        // {url: '/img/notfound/img-placeholder_landscape.jpg'}
      ],
      OperatingHours: [],
      demographics: [
        {
          id: `spending`,
          icon: `adx-ic_cards`,
          text: `Average Spending`
        },
        {
          id: `job`,
          icon: `adx-ic_briefcase`,
          text: `Occupation`
        },
        {
          id: `profile`,
          icon: `icon-knowledge-base`,
          text: `Visitor Profile`
        },
      ],
      isOpen: false,
      currentSlide: 1,
      countSlide: null,
      pub_id: null,
      deviceId: null,
      imgLoaded: false,
      infoLoaded: false,
      savedLoading: false,
      isAudienceDisplayed: null,
      placeholderImage:[{
        id: 0,
        url: `/img/notfound/img-placeholder_landscape.jpg`,
        thumbnail : `/img/notfound/img-placeholder_landscape.jpg`,
        is_primary: false,
        caption: 'placeholder'
      }],
    }
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
    isPhotosAvailable(){
      return this.detailSlider.length > 0
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { pub_id } = this.$route.params
    this.pub_id = pub_id
    this.loadData()
    this.loadImage()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    showCampaign(){
      if (this.token) {
        this.isShownCampaign = true
        this.getCampaigns()
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.fullPath }})
      }
    },
    getCampaigns() {
      if (this.campaigns.length == 0){
        (async () => {
          this.isLoadingCampaign = true
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          this.isLoadingCampaign = false
          if (response.status == 200) {
            this.campaigns = response.data
          } else {
            // this.error = response.data.error
          }
        })();
      }
    },
    appendCampaign(item) {
      if (this.isLoadingAppend.length == 0) {
        (async () => {
          this.isLoadingAppend.push(item.id)
          const data = {
            channel_name: 'idooh',
            channel_id: this.deviceId
          }
          const response = await api.patch(apiV2.campaignAddListing(item.id), data, { needToken: true })
          this.isLoadingAppend = []
          if (response.status == 200) {
            this.isShownCampaign = false
            this.$router.push({ path: `/${item.id}/campaign-editor` })
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'sorry something went wrong!',
              type: 'warn'
            });
          }
        })();
      }
    },
    createCampaignUntitled() {
      (async () => {
        this.isCreateCampaign = true
        const data = {
          campaign_channel: [
            {
              name: 'idooh',
              list_id: [this.deviceId]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isShownCampaign = false
          this.$router.push({ path: `/${response.data['data']['id']}/campaign-editor` })
        } else {
          this.error = response.data.error
        }
      })();
    },
    loadData () {
      (async () => {
        const { data } = await api.get(apiV2.deviceDetail(this.pub_id))
        this.mapData(data)
        this.infoLoaded = true
      })();
    },
    // loadImage () {
    //   (async () => {
    //     const { data } = await api.get(apiV2.deviceDetailImages(this.pub_id))
    //     this.detailSlider = data.map(el => {
    //       return {
    //         id: el.id,
    //         url: el.image,
    //         thumbnail: el.thumbnail_720,
    //         is360: el.is_360,
    //         viewer_url: el.viewer_url
    //       }
    //     })
    //     if(this.detailSlider.length != 0) this.imgLoaded = true
    //   })();
    // },
    loadImage () {
      (async () => {
        this.detailSlider = []
        const { data } = await api.get(apiV2.deviceDetailImages(this.pub_id), { needToken: true })
        let image = []
        let isPrimaryExist = false
        data.map(el => {
          if(el.is_primary){
            isPrimaryExist = true
            image.push({
              id: el.id,
              url: el.image,
              thumbnail : el.thumbnail_720,
              is_primary: el.is_primary,
              caption: el.caption
            })
          }
        })
        this.imgLoaded = true
        if (!isPrimaryExist && data.length > 0){
          let firstPic = data[0]
          this.detailSlider.push({
            id: firstPic.id,
            url: firstPic.image,
            thumbnail : firstPic.thumbnail_720,
            is_primary: firstPic.is_primary,
            caption: firstPic.caption
          })
        } else if (image.length > 0) {
          this.detailSlider.push(image[0])
        }
      })();
    },
    mapData (data) {
      this.deviceId = data.id
      this.location = {
        title: data.location_name,
        placement: data.placement,
        price: data.price,
        dailyVisitor: data.audience_daily,
        address: (data.address ? data.address : 'N/A'),
        description: data.location_inside.about,
        audio: data.audio_support,
        specification: `
          ${data.device_size} - ${data.orientation}
        `.trim(),
        playback: data.playback,
        forbidden: (data.forbidden_ads ? data.forbidden_ads : 'There\'s no forbidden ads'),
        surrounding: 'Supermarket',
        traffic: 140,
        media_description: data.description
      }
      this.media = {
        size: data.device_size,
        screen: data.screen,
        placement: data.placement,
        resolution: data.resolution,
        playback: data.playback
      }
      this.OperatingHours = data.operating_hours.map(el => {
        let data = {}
        data.day = el.day
        data.isOpen = el.is_open
        if (el.is_open) {
          data.time = `${el.start} - ${el.end}`
        } else {
          data.time = 'closed'
        }
        return data
      })
      this.demographics.map(el => {
        switch (el.id) {
          case `spending`:
            el.text = `Average Spending ${formatNumber(data.average_spending)} / ${data.subject_spending_display} / ${data.period_spending_display}`
            break;
          case `job`:
            if (data.profile) {
              el.text = `Occupation ${data.profile.job.join(`, `)}`
            }
            break;
          case `profile`:
            if (data.profile) {
              el.text = `Visitor Profile ${data.profile.ses.join(` `)}`
            }
            break;
        }
        return el
      })
      this.demographics = this.demographics.filter(element => element.text !== ``)
      this.isAudienceDisplayed = data.is_audience_displayed
    },
    addRemoveDevice(item) {
      (async () => {
        this.savedLoading = true
        let category = this.category
        const isLogin = this.token
        if(isLogin) {
          const { response, msg } = await this.$store.dispatch('addRemoveSaved', {item: item, category: category})
          const text = `${this.location.title} ${msg.text.slice(12)}`
          this.$notify({
            group: 'saved',
            title: msg.title,
            text: text,
            type: msg.type
          });
          this.savedLoading = false
        } else {
          const currentRoute = this.$route.path
          this.$router.push({name: 'signin', query: { next: currentRoute }})
        }
      })();
    },
    iconSelection(id) {
      const listSaved = this.defaultSaved[this.category]
      const isLogin = this.token
      if(isLogin && listSaved){
        if (listSaved.includes(id)) {
          return 'adx-ic_check'
        } else {
          return 'adx-ic_plus'
        }
      } else {
        return 'adx-ic_plus'
      }
    },
    savedText(id) {
      const listSaved = this.defaultSaved[this.category]
      const isLogin = this.token
      if(isLogin && listSaved){
        if (listSaved.includes(id)) {
          return `Saved`
        } else {
          return `Save`
        }
      } else {
        return `Save`
      }
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.detail-airport__banner__placeholder {
  .slick-slide {
    width: 100%;

    img.detail {
      object-fit: unset;
    }
  }
  .slick-slide:first-child{
    margin-left: 0px;
  }
}

.detail-airport__banner__img {
  .slick-slide {
    width: 100;
  }
  .slick-slide:first-child{
    margin-left: 0px;
  }
}

@include breakpoint(md) {
  .detail-airport__banner__img {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
  .detail-airport__banner__placeholder {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
}
</style>
